import { useQuery } from "@tanstack/react-query";

import { usePageTitle } from "@/lib/use-page-title";
import { apiClient } from "@/lib/api";

/** Un-authenticated health probe page - hits /health on the API. */
export function HealthPage(): JSX.Element {
  usePageTitle("Health");
  const health = useQuery({
    queryKey: ["health"],
    queryFn: () => apiClient.health(),
    retry: false,
  });

  return (
    <main className="min-h-screen bg-background p-8 text-foreground">
      <div className="mx-auto max-w-xl">
        <h1 className="mb-4 text-xl font-semibold">Admin API health</h1>
        {health.isLoading && <p>Checking…</p>}
        {health.isError && (
          <pre className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
            {health.error instanceof Error ? health.error.message : "error"}
          </pre>
        )}
        {health.data && (
          <pre className="rounded-md bg-muted p-4 text-sm">
            {JSON.stringify(health.data, null, 2)}
          </pre>
        )}
      </div>
    </main>
  );
}
